module.exports = __webpack_public_path__ + "static/ss8.71a5ea4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/projects/studysmart/ss/ss8.png
// module id = 1204
// module chunks = 81679748166845